import { colors } from './colors';
export const common = {
    fontFamily: 'Inter, -apple-system, BlinkMacSystemFont, Segoe UI, Roboto, Helvetica, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol',
};
export const text = {
    headingXXL: {
        fontFamily: common.fontFamily,
        fontStyle: 'normal',
        fontWeight: 600,
        fontSize: '40px',
        lineHeight: '56px',
        color: colors.neutral.ink.base,
        textDecoration: 'none',
        letterSpacing: '-0.022rem',
    },
    headingXL: {
        fontFamily: common.fontFamily,
        fontStyle: 'normal',
        fontWeight: 600,
        fontSize: '28px',
        lineHeight: '40px',
        color: colors.neutral.ink.base,
        textDecoration: 'none',
        letterSpacing: '-0.02rem',
    },
    headingLarge: {
        fontFamily: common.fontFamily,
        fontStyle: 'normal',
        fontWeight: 600,
        fontSize: '24px',
        lineHeight: '32px',
        color: colors.neutral.ink.base,
        textDecoration: 'none',
        letterSpacing: '-0.019rem',
    },
    headingMedium: {
        fontFamily: common.fontFamily,
        fontStyle: 'normal',
        fontWeight: 600,
        fontSize: '20px',
        lineHeight: '28px',
        color: colors.neutral.ink.base,
        textDecoration: 'none',
        letterSpacing: '-0.017rem',
    },
    headingSmall: {
        fontFamily: common.fontFamily,
        fontStyle: 'normal',
        fontWeight: 600,
        fontSize: '16px',
        lineHeight: '20px',
        color: colors.neutral.ink.base,
        textDecoration: 'none',
        letterSpacing: '-0.011rem',
    },
    headingTable: {
        fontFamily: common.fontFamily,
        fontStyle: 'normal',
        fontWeight: 600,
        fontSize: '12px',
        lineHeight: '16px',
        color: colors.neutral.ink.base,
        textDecoration: 'none',
        letterSpacing: '0',
    },
    subheadingLarge: {
        fontFamily: common.fontFamily,
        fontStyle: 'normal',
        fontWeight: 'normal',
        fontSize: '20px',
        lineHeight: '28px',
        color: colors.neutral.ink.light,
        textDecoration: 'none',
        letterSpacing: '-0.017rem',
    },
    subheadingMedium: {
        fontFamily: common.fontFamily,
        fontStyle: 'normal',
        fontWeight: 'normal',
        fontSize: '16px',
        lineHeight: '24px',
        color: colors.neutral.ink.light,
        textDecoration: 'none',
        letterSpacing: '-0.011rem',
    },
    subheadingSmall: {
        fontFamily: common.fontFamily,
        fontStyle: 'normal',
        fontWeight: 'normal',
        fontSize: '12px',
        lineHeight: '16px',
        color: colors.neutral.ink.light,
        textDecoration: 'none',
        letterSpacing: '0',
    },
    subheadingSmallBold: {
        fontFamily: common.fontFamily,
        fontStyle: 'normal',
        fontWeight: 600,
        fontSize: '12px',
        lineHeight: '16px',
        color: colors.neutral.ink.base,
        textDecoration: 'none',
        letterSpacing: '0',
    },
    body: {
        fontFamily: common.fontFamily,
        fontStyle: 'normal',
        fontWeight: 'normal',
        fontSize: '14px',
        lineHeight: '20px',
        color: colors.neutral.ink.base,
        textDecoration: 'none',
        letterSpacing: '-0.006rem',
    },
    bodySmall: {
        fontFamily: common.fontFamily,
        fontStyle: 'normal',
        fontWeight: 'normal',
        fontSize: '12px',
        lineHeight: '16px',
        color: colors.neutral.ink.base,
        textDecoration: 'none',
        letterSpacing: '0',
    },
    bodyBold: {
        fontFamily: common.fontFamily,
        fontStyle: 'normal',
        fontWeight: 600,
        fontSize: '14px',
        lineHeight: '20px',
        color: colors.neutral.ink.base,
        textDecoration: 'none',
        letterSpacing: '-0.006rem',
    },
    bodyBoldDark: {
        fontFamily: common.fontFamily,
        fontStyle: 'normal',
        fontWeight: 600,
        fontSize: '14px',
        lineHeight: '20px',
        color: colors.neutral.ink.dark,
        textDecoration: 'none',
        letterSpacing: '0',
    },
    bodySmallBold: {
        fontFamily: common.fontFamily,
        fontStyle: 'normal',
        fontWeight: 600,
        fontSize: '12px',
        lineHeight: '16px',
        color: colors.neutral.ink.base,
        textDecoration: 'none',
        letterSpacing: '0',
    },
    button: {
        fontFamily: common.fontFamily,
        fontStyle: 'normal',
        fontWeight: 600,
        fontSize: '16px',
        lineHeight: '24px',
        color: colors.secondary.blue.base,
        textDecoration: 'none',
        letterSpacing: '-0.011rem',
    },
    buttonSmall: {
        fontFamily: common.fontFamily,
        fontStyle: 'normal',
        fontWeight: 600,
        fontSize: '14px',
        lineHeight: '20px',
        color: colors.secondary.blue.base,
        textDecoration: 'none',
        letterSpacing: '-0.006rem',
    },
    linkLarge: {
        fontFamily: common.fontFamily,
        fontStyle: 'normal',
        fontWeight: 'normal',
        fontSize: '20px',
        lineHeight: '28px',
        color: colors.secondary.blue.base,
        textDecoration: 'underline',
        letterSpacing: '-0.017rem',
    },
    linkMedium: {
        fontFamily: common.fontFamily,
        fontStyle: 'normal',
        fontWeight: 'normal',
        fontSize: '16px',
        lineHeight: '24px',
        color: colors.secondary.blue.base,
        textDecoration: 'underline',
        letterSpacing: '-0.011rem',
    },
    link: {
        fontFamily: common.fontFamily,
        fontStyle: 'normal',
        fontWeight: 'normal',
        fontSize: '14px',
        lineHeight: '20px',
        color: colors.secondary.blue.base,
        textDecoration: 'underline',
        letterSpacing: '-0.006rem',
    },
    linkSmall: {
        fontFamily: common.fontFamily,
        fontStyle: 'normal',
        fontWeight: 'normal',
        fontSize: '12px',
        lineHeight: '16px',
        color: colors.secondary.blue.base,
        textDecoration: 'underline',
        letterSpacing: '0',
    },
    inputLabel: {
        fontFamily: common.fontFamily,
        fontStyle: 'normal',
        fontWeight: 600,
        fontSize: '14px',
        lineHeight: '20px',
        color: colors.neutral.ink.base,
        textDecoration: 'none',
        letterSpacing: '-0.006rem',
    },
    inputLabelSmall: {
        fontFamily: common.fontFamily,
        fontStyle: 'normal',
        fontWeight: 600,
        fontSize: '12px',
        lineHeight: '16px',
        color: colors.neutral.ink.base,
        textDecoration: 'none',
        letterSpacing: '0',
    },
    hintText: {
        fontFamily: common.fontFamily,
        fontStyle: 'normal',
        fontWeight: 'normal',
        fontSize: '12px',
        lineHeight: '16px',
        color: colors.neutral.ink.light,
        textDecoration: 'none',
        letterSpacing: '0',
    },
    placeholder: {
        fontFamily: common.fontFamily,
        fontStyle: 'normal',
        fontWeight: 'normal',
        fontSize: '14px',
        lineHeight: '20px',
        color: colors.neutral.ink.lightest,
        textDecoration: 'none',
        letterSpacing: '-0.006rem',
    },
    placeholderSmall: {
        fontFamily: common.fontFamily,
        fontStyle: 'normal',
        fontWeight: 'normal',
        fontSize: '12px',
        lineHeight: '16px',
        color: colors.neutral.ink.lightest,
        textDecoration: 'none',
        letterSpacing: '0',
    },
    placeholderCode: {
        fontFamily: common.fontFamily,
        fontStyle: 'normal',
        fontWeight: 'normal',
        fontSize: '14px',
        lineHeight: '20px',
        color: colors.neutral.ink.lightest,
        textDecoration: 'none',
        letterSpacing: '0.5rem',
    },
    placeholderCodeSmall: {
        fontFamily: common.fontFamily,
        fontStyle: 'normal',
        fontWeight: 'normal',
        fontSize: '12px',
        lineHeight: '16px',
        color: colors.neutral.ink.lightest,
        textDecoration: 'none',
        letterSpacing: '0.375rem',
    },
    error: {
        fontFamily: common.fontFamily,
        fontStyle: 'normal',
        fontWeight: 600,
        fontSize: '14px',
        lineHeight: '20px',
        color: colors.secondary.red.base,
        textDecoration: 'none',
        letterSpacing: '-0.006rem',
    },
    errorSmall: {
        fontFamily: common.fontFamily,
        fontStyle: 'normal',
        fontWeight: 600,
        fontSize: '12px',
        lineHeight: '16px',
        color: colors.secondary.red.base,
        textDecoration: 'none',
        letterSpacing: '0',
    },
    successSmall: {
        fontFamily: common.fontFamily,
        fontStyle: 'normal',
        fontWeight: 600,
        fontSize: '12px',
        lineHeight: '16px',
        color: colors.secondary.green.base,
        textDecoration: 'none',
        letterSpacing: '0',
    },
};
//# sourceMappingURL=text.js.map